import { FolderOpen } from "lucide-react";
import { PATH_WORKSPACE } from "config";

/**
 * The one "All projects" escape hatch shared by every sidebar and menu.
 * Defined here (not in a settings page module) so app chrome can use it
 * without importing page-level code.
 */
export const WORKSPACE_PRODUCT_NAV = {
  id: "all-projects",
  title: "All projects",
  description: "Return to your project list",
  path: PATH_WORKSPACE.workspaceProjects,
  icon: <FolderOpen className="w-4 h-4" />,
} as const;
